<template>
    <div class="col-12 col-md-4 col-lg-4 mt-2">
        <div v-if="letter">
            <div v-if="letter.letter_video">
                <div v-if="letter.video_type == 1">
                    <iframe v-if="letter.letter_video" style="margin:auto;height: 260px;width: 100%;" width="560" height="315" :src="`${letter.letter_video}`" :title="letter.letter_name" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div v-else-if="letter.video_type == 0 || letter.video_type == null">
                    <vue3-video-player :src="letter.letter_video"  v-if="letter.letter_video" ref="videocontainer" :title="letter.letter_name" :view-core="viewCore.bind(null, letter.letter_id)"></vue3-video-player>
                </div>
                <div v-else>
                    <img :src="letter.letter_image" class="img-fluid" alt="img-placeholder" />
                </div>
            </div>
            <div v-else>
                <img :src="letter.letter_image" class="img-fluid" alt="img-placeholder" />
            </div>
        </div>


    </div>
</template>
<script>
import { ref } from 'vue'
export default {
    props: {
        letter:{
            type: [Array, Object]
        }
    },
    setup(){
        const videoId=ref(),
        videoType=ref(),
        videoUrl=ref(),
        players=ref();
        return{
            videoId,
            videoType,
            videoUrl,
            players
        }
    },
    watch:{
        'letter'(value) {
            console.log(value)
        },
    },
    computed: {
    },
    methods:{
        pause(id){
            if(this.letter.video_type == 0 || this.letter.video_type == null){
                this.players && this.players[id] && this.players[id].pause()
            }
        },
        viewCore (id, player) {
            this.players[id] = player
        },
    }
}
</script>